<template>
    <div class="row">
        <div class="col-12 text-center" v-if="!item">
            <div class="spinner-grow" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>

        <!-- main toolbar -->
        <div class="col-12" v-if="item">
            <div class="card">
                <div class="card-body">
                    <div class="form-group float-left mr-2">
                        <label for="item_name">Показывать на сайте</label><br>

                        <input type="checkbox" id="switch_show" v-model="item.show" data-switch="success"
                            @change="editItem()" />
                        <label for="switch_show" data-on-label="Да" data-off-label="Нет"></label>
                    </div>

                    <div class="form-group float-left mr-2">
                        <label for="item_name">Перейти на страницу на сайте</label><br>

                        <a :href="app_frontend_host + `/portfolio/${item._id}?preview=true`"
                            class="btn btn-sm btn-rounded btn-outline-primary" target="_blank">перейти</a>
                    </div>

                    <div class="form-group float-left">
                        <label for="item_name">Просмотров</label><br>
                        <label> <i class="mdi mdi-eye"></i> {{ item.views }}</label>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-12 col-lg-8 order-2 order-lg-1" v-if="item">

            <!-- descriptions -->
            <div class="card">
                <div class="card-body">
                    <!-- 1 row -->
                    <div class="form-group">
                        <label>Краткое описание объекта</label>
                        <vue-editor v-model="item.description"
                            :editorToolbar='[["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }]]'></vue-editor>
                    </div>

                </div>
                <div class="card-footer">
                    <button v-if="!loading" type="submit" class="btn btn-primary"
                        @click.prevent="editItem()">Сохранить</button>
                    <button v-else class="btn btn-primary" type="button" disabled>
                        <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                        Отправка данных...
                    </button>
                </div>
            </div>

            <!-- photos -->
            <div class="card">
                <div class="card-body">
                    <h3>3d рендеры</h3>

                    <select class="form-control" v-model="item._photos_type">
                        <option v-for="(value, key) in app_mongo_desc.portfolioDescription.room_photo_type" :key="key"
                            :value="key">{{ value }}</option>
                    </select>

                    <vue-dropzone ref="dropzone_photos" id="dropzone_photos" :options="dropzone_photos" class="mb-1"
                        @vdropzone-sending="beforeImageUpload('room_photos', i, ...arguments)"
                        @vdropzone-success="imageUploadSuccess('room_photos', i, ...arguments)"></vue-dropzone>

                    <table v-if="item.photos && item.photos.length" class="table table-striped table-centered mb-1">
                        <thead>
                            <tr>
                                <th>Photo</th>
                                <th>Path</th>
                                <th>Type</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(photo, i) in item.photos" :key="photo._id" v-if="photo.type == item._photos_type">
                                <td class="table-photo">
                                    <a :href="getCDNUrl(photo.path)" target="_blank">
                                        <img :src="getCDNUrl(photo.path, ['r=100'])" alt="table-user" />
                                    </a>
                                </td>
                                <td>{{ photo.path }}</td>
                                <td>{{ app_mongo_desc.portfolioDescription.room_photo_type[photo.type] }}</td>
                                <td>
                                    <button class="btn btn-sm btn-outline-secondary mr-1"
                                        @click.prevent="photoSort(i, -1)"><i class="mdi mdi-chevron-double-up"></i></button>
                                    <button class="btn btn-sm btn-outline-secondary mr-3"
                                        @click.prevent="photoSort(i, 1)"><i
                                            class="mdi mdi-chevron-double-down"></i></button>

                                    <button class="btn btn-sm btn-danger" @click.prevent="deleteImage(i)"><i
                                            class="mdi mdi-window-close"></i></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
                <div class="card-footer">
                    <button v-if="!loading" type="submit" class="btn btn-primary"
                        @click.prevent="editItem()">Сохранить</button>
                    <button v-else class="btn btn-primary" type="button" disabled>
                        <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                        Отправка данных...
                    </button>
                </div>
            </div>

            <!-- videos -->
            <div class="card">
                <div class="card-body">
                    <h3>Видео</h3>

                    <div class="row">
                        <div class="col-md-12 col-lg-6">
                            <div class="form-group">
                                <label>Название ролика</label>
                                <input type="text" v-model="videoForm.title" class="form-control">
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-6">
                            <div class="form-group">
                                <label>ID ролика <small>(в адресе после v=. Например
                                        https://www.youtube.com/watch?v=QVhgy6qbsVU, тут ID = QVhgy6qbsVU)</small></label>
                                <input type="text" v-model="videoForm.id" class="form-control">
                            </div>
                        </div>
                    </div>
                    <button type="submit" class="btn btn-secondary margin-bottom" @click.prevent="addVideo()">Добавить
                        видео</button>

                    <table v-if="item.videos && item.videos.length" class="table table-striped table-centered mb-1">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Title</th>
                                <th>Preview</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(video, i) in item.videos" :key="video._id">
                                <td>{{ video.id }}</td>
                                <td>{{ video.title }}</td>
                                <td>
                                    <iframe width="300" height="170" :src="`https://www.youtube.com/embed/${video.id}`"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                </td>
                                <td>
                                    <button class="btn btn-sm btn-outline-secondary mr-1"
                                        @click.prevent="videoSort(i, -1)"><i class="mdi mdi-chevron-double-up"></i></button>
                                    <button class="btn btn-sm btn-outline-secondary mr-3"
                                        @click.prevent="videoSort(i, 1)"><i
                                            class="mdi mdi-chevron-double-down"></i></button>

                                    <button class="btn btn-sm btn-danger" @click.prevent="deleteVideo(i)"><i
                                            class="mdi mdi-window-close"></i></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
                <div class="card-footer">
                    <button v-if="!loading" type="submit" class="btn btn-primary"
                        @click.prevent="editItem()">Сохранить</button>
                    <button v-else class="btn btn-primary" type="button" disabled>
                        <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                        Отправка данных...
                    </button>
                </div>
            </div>

            <!-- articles -->
            <div class="card">
                <div class="card-body">
                    <h3>Статьи</h3>

                    <div class="row">
                        <div class="col-md-12 col-lg-6">
                            <div class="form-group">
                                <label>Название статьи</label>
                                <input type="text" v-model="articlesForm.title" class="form-control">
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-6">
                            <div class="form-group">
                                <label>Ссылка на статью</label>
                                <input type="text" v-model="articlesForm.url" class="form-control">
                            </div>
                        </div>
                    </div>
                    <button type="submit" class="btn btn-secondary margin-bottom" @click.prevent="addArticle()">Добавить
                        статью</button>

                    <table v-if="item.articles && item.articles.length" class="table table-striped table-centered mb-1">
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>URL</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(article, i) in item.articles" :key="article._id">
                                <td>
                                    <a :href="article.url" target="_blank" rel="noopener nofollow">
                                        <img :src="`${backend_url}/static/favicon/${article.domain}`">
                                        {{ article.title }}
                                    </a>
                                </td>
                                <td>{{ article.url }}</td>
                                <td>
                                    <button class="btn btn-sm btn-outline-secondary mr-1"
                                        @click.prevent="articleSort(i, -1)"><i
                                            class="mdi mdi-chevron-double-up"></i></button>
                                    <button class="btn btn-sm btn-outline-secondary mr-3"
                                        @click.prevent="articleSort(i, 1)"><i
                                            class="mdi mdi-chevron-double-down"></i></button>

                                    <button class="btn btn-sm btn-danger" @click.prevent="deleteArticle(i)"><i
                                            class="mdi mdi-window-close"></i></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
                <div class="card-footer">
                    <button v-if="!loading" type="submit" class="btn btn-primary"
                        @click.prevent="editItem()">Сохранить</button>
                    <button v-else class="btn btn-primary" type="button" disabled>
                        <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                        Отправка данных...
                    </button>
                </div>
            </div>

        </div>
        <div class="col-md-12 col-lg-4 order-1 order-lg-2" v-if="item">
            <div class="card">
                <div class="card-body">
                    <!-- 2 row -->
                    <div class="form-group text-center">
                        <label>Обложка</label>
                        <vue-dropzone ref="dropzone_cover" id="dropzone_cover" :options="dropzone_cover"
                            @vdropzone-sending="beforeImageUpload('cover', 'dropzone_cover', ...arguments)"
                            @vdropzone-success="imageUploadSuccess('cover', 'dropzone_cover', ...arguments)"></vue-dropzone>
                        <img :src="getCDNUrl(item.cover.path)" v-if="item.cover && item.cover.path" class="img-fluid mt-2">
                    </div>

                    <div class="form-group mt-5">
                        <label>Название</label>
                        <input type="text" v-model="item.name" class="form-control">
                    </div>

                    <div class="form-group">
                        <label>Тип</label>
                        <select class="form-control" v-model="item.type">
                            <option v-for="(value, key) in app_mongo_desc.portfolioDescription.type" :key="key"
                                :value="key">{{ value }}</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label>Стиль дизайна</label>
                        <select class="form-control" v-model="item.design_style">
                            <option v-for="(value, key) in app_mongo_desc.portfolioDescription.design_style" :key="key"
                                :value="key">{{ value }}</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label>Площадь объекта</label>
                        <input type="number" min="1" v-model="item.square" class="form-control">
                    </div>

                    <div class="form-group">
                        <label>Количество комнат</label>
                        <input type="number" min="1" v-model="item.room_count" class="form-control">
                    </div>

                    <hr>

                    <h5>SEO settings</h5>
                    <button v-if="!ai_loading" type="button" class="btn btn-info" @click.prevent="aiSEO()">заполнить с
                        помощью AI</button>
                    <button v-else class="btn btn-info" type="button" disabled>
                        <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                        Отправка данных...
                    </button>

                    <p>Важно, чтобы статья была полностью написана, чтобы AI смог взять ее как за контекст</p>

                    <div class="form-group">
                        <label>SEO title</label>
                        <input type="text" v-model="item.seo.title" class="form-control">
                    </div>

                    <div class="form-group">
                        <label>SEO description</label>
                        <textarea v-model="item.seo.description" class="form-control"></textarea>
                    </div>

                    <div class="form-group">
                        <label>SEO keywords</label>
                        <input type="text" v-model="item.seo.keywords" class="form-control">
                    </div>


                    <button v-if="!loading" type="submit" class="btn btn-primary"
                        @click.prevent="editItem()">Сохранить</button>
                    <button v-else class="btn btn-primary" type="button" disabled>
                        <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                        Отправка данных...
                    </button>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import vue2Dropzone from 'vue2-dropzone'
import { VueEditor } from "vue2-editor";

import log from '@/plugins/log'
import { to } from '@/plugins/utils'
import '@/plugins/quill'

import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
    name: 'PortfolioEdit',
    data: () => {
        return {
            item: null,

            roomDesc: {
                _show: true,
                _photos_type: 'daylight',
                name: null,
                type: null,
                square: null,
                description: null,
                photos: null
            },

            roomPhotoDesc: {
                url: null,
                path: null,
                type: null
            },

            loading: false,
            ai_loading: false,

            dropzoneOptions: {
                paramName: "image",
                acceptedFiles: 'image/*',
                parallelUploads: 1,
                createImageThumbnails: false
            },

            videoForm: {},
            _videoForm: {
                title: '',
                id: ''
            },

            articlesForm: {},
            _articlesForm: {
                title: '',
                url: '',
                domain: ''
            }
        }
    },
    computed: {
        ...mapState([
            'app_mongo_desc',
            'app_cdn_host',
            'backend_url',
            'app_token',
            'app_frontend_host'
        ]),
        id() {
            return this.$route.params.id
        },
        dropzone_cover() {
            return Object.assign({}, this.dropzoneOptions, {
                url: this.backend_url + '/portfolio/uploadImage/' + this.id,
                maxFiles: 1,
                headers: {
                    'Authorization': this.app_token
                }
            })
        },
        dropzone_photos() {
            return Object.assign({}, this.dropzoneOptions, {
                url: this.backend_url + '/portfolio/uploadImage/' + this.id,
                headers: {
                    'Authorization': this.app_token
                }
            })
        }
    },
    async beforeMount() {
        await this.getItem()
        this.resetVideoForm()
        this.resetArticlesForm()
    },
    mounted() {
        log.debug(`/views/portfolio/edit/${this.id}`, 'mounted')
    },
    methods: {
        async getItem() {
            var [err, response] = await to(this.$http.get(`/portfolio/edit/${this.id}`))
            if (err) {
                log.error(`/views/portfolio/edit/${this.id}`, 'methods.getItem', '$http.request', err)
                return $.NotificationApp.send("Ошибка", err.message, "top-right", "", "error")
            }

            if (!response.data.success) {
                log.error(`/views/portfolio/edit/${this.id}`, 'methods.getItem', '$http.response', response.data)
                return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
            }

            log.debug('/views/portfolio/add', 'methods.addItem', '$http.request', response.data)
            response.data.item._photos_type = 'daylight'

            this.item = response.data.item
        },
        async editItem() {
            this.loading = true
            var [err, response] = await to(this.$http.post(`/portfolio/edit/${this.id}`, this.item))
            if (err) {
                this.loading = false
                log.error(`/views/portfolio/edit/${this.id}`, 'methods.editItem', '$http.request', err)
                return $.NotificationApp.send("Ошибка", err.message, "top-right", "", "error")
            }

            if (!response.data.success) {
                this.loading = false
                log.error(`/views/portfolio/edit/${this.id}`, 'methods.editItem', '$http.response', response.data)
                return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
            }

            this.loading = false
            log.debug(`/views/portfolio/edit/${this.id}`, 'methods.editItem', '$http.request', response.data)
            return $.NotificationApp.send("Успешно", '', "top-right", "", "success")

            this.item = response.data.item
        },

        async aiSEO() {
            this.ai_loading = true;

            var [err, response] = await to(this.$http.post(`/seo/generate`, {
                prompt: [
                    `Type: Portfolio project`,
                    `Name: ${this.item.name}`,
                    `Description: ${this.item.description.replace(/<img .*?>/g, '')}`,
                    `Style: ${this.item.design_style}`,
                ].join(';')
            }))

            if (err) {
                this.ai_loading = false
                log.error(`/views/blog/edit/${this.id}`, 'methods.aiSEO', '$http.request', err)
                return $.NotificationApp.send("Ошибка", err.message, "top-right", "", "error")
            }

            if (!response.data.success) {
                this.ai_loading = false
                log.error(`/views/blog/edit/${this.id}`, 'methods.aiSEO', '$http.response', response.data)
                return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
            }

            this.ai_loading = false

            this.item.seo.title = response.data.result.title;
            this.item.seo.description = response.data.result.description;
            this.item.seo.keywords = response.data.result.keywords;
        },

        addRoom() {
            if (!this.item.rooms) this.item.rooms = []
            this.item.rooms.push(Object.assign({}, this.roomDesc))
        },
        roomShowToggle(index) {
            let item = this.item.rooms[index]
            item._show = !item._show
            this.$set(this.item.rooms, index, item)
        },
        roomShowToggleAll(value) {
            this.item.rooms.forEach((room, index) => {
                room._show = value
                this.$set(this.item.rooms, index, room)
            })
        },
        roomSort(index, direction) {
            let obj1 = this.item.rooms[index]
            let obj2 = this.item.rooms[index + direction]

            if (obj1 && obj2) {
                this.$set(this.item.rooms, index, obj2)
                this.$set(this.item.rooms, (index + direction), obj1)
            }
        },
        deleteRoom(index) {
            if (!confirm('Уверены, что хотите удалить комнату?')) return;

            this.item.rooms.splice(index, 1);
        },

        photoSort(index, direction) {
            let photos = []
            this.item.photos.forEach((photo, i) => {
                if (photo.type == this.item._photos_type)
                    photos.push(i)
            })

            let filteredIndex = photos.indexOf(index)
            if (filteredIndex == -1) return;

            let obj1 = this.item.photos[index]
            let obj2 = this.item.photos[photos[filteredIndex + direction]]

            if (obj1 && obj2) {
                this.$set(this.item.photos, index, obj2)
                this.$set(this.item.photos, photos[filteredIndex + direction], obj1)
            }
        },
        deleteImage(photoIndex) {
            if (!confirm('Уверены, что хотите удалить фото?')) return;

            this.item.photos.splice(photoIndex, 1);
        },

        /* dropzone upload */
        beforeImageUpload(type, ref, file, xhr, formData) {
            formData.append('type', type)
        },
        imageUploadSuccess(type, ref, file, response) {
            if (!response.success) {
                log.error(`/views/portfolio/edit/${this.id}`, 'methods.imageUploadSuccess', '$http.response', response)
                return $.NotificationApp.send("Ошибка", response.error, "top-right", "", "error")
            }

            if (type == 'cover') {
                this.item.cover = {
                    url: response.image.imageUrl,
                    path: response.image.imagePath
                }
                this.editItem()

                this.$refs[ref].removeAllFiles()
            }
            if (type == 'room_photos') {
                if (!this.item.photos) this.item.photos = []
                this.item.photos.push(Object.assign({}, this.roomPhotoDesc, {
                    url: response.image.imageUrl,
                    path: response.image.imagePath,
                    type: this.item._photos_type
                }))

                this.editItem()
            }
        },
        /* editor upload */
        async editorImgageUpload(file, Editor, cursorLocation, resetUploader) {
            var formData = new FormData();
            formData.append("image", file, file.name);
            formData.append("type", 'stage_2');

            var [err, response] = await to(this.$http.post(`/portfolio/uploadImage/${this.id}`, formData))
            if (err) {
                log.error(`/views/portfolio/edit/${this.id}`, 'methods.editorImgageUpload', '$http.request', err)
                return $.NotificationApp.send("Ошибка", err.message, "top-right", "", "error")
            }
            if (!response.data.success) {
                log.error(`/views/portfolio/edit/${this.id}`, 'methods.editorImgageUpload', '$http.response', response)
                return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
            }
            log.debug('/views/portfolio/add', 'methods.editorImgageUpload', '$http.request', response.data)

            Editor.insertEmbed(cursorLocation, "imageBlot", {
                src: this.getCDNUrl(response.data.image.imagePath),
                path: response.data.image.imagePath
            });
            resetUploader();
        },
        getCDNUrl(path, modify = []) {
            let modification_string = modify.length ? modify.join(',') + '/_/' : ''
            return `${this.app_cdn_host}/i/${modification_string}${path}`
        },
        resetVideoForm() {
            this.videoForm = Object.assign({}, this._videoForm)
        },
        addVideo() {
            if (!this.item.videos) this.item.videos = []
            this.item.videos.push(this.videoForm)

            this.resetVideoForm()
        },
        videoSort(index, direction) {
            let obj1 = this.item.videos[index]
            let obj2 = this.item.videos[index + direction]

            if (obj1 && obj2) {
                this.$set(this.item.videos, index, obj2)
                this.$set(this.item.videos, (index + direction), obj1)
            }
        },
        deleteVideo(index) {
            if (!confirm('Уверены, что хотите удалить видео?')) return;
            this.item.videos.splice(index, 1);
        },

        resetArticlesForm() {
            this.articlesForm = Object.assign({}, this._articlesForm)
        },
        addArticle() {
            if (!this.item.articles) this.item.articles = []

            //get domain
            if (!this.validURL(this.articlesForm.url)) return alert('URL is not valid')
            this.articlesForm.domain = this.extractHostname(this.articlesForm.url)

            this.item.articles.push(this.articlesForm)

            this.resetArticlesForm()
        },
        articleSort(index, direction) {
            let obj1 = this.item.articles[index]
            let obj2 = this.item.articles[index + direction]

            if (obj1 && obj2) {
                this.$set(this.item.articles, index, obj2)
                this.$set(this.item.articles, (index + direction), obj1)
            }
        },
        deleteArticle(index) {
            if (!confirm('Уверены, что хотите удалить статью?')) return;
            this.item.articles.splice(index, 1);
        },

        extractHostname(url) {
            var hostname;

            if (url.indexOf("//") > -1) {
                hostname = url.split('/')[2];
            } else {
                hostname = url.split('/')[0];
            }
            hostname = hostname.split(':')[0];
            hostname = hostname.split('?')[0];

            return hostname;
        },
        validURL(str) {
            var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
            return !!pattern.test(str);
        }
    },
    components: {
        vueDropzone: vue2Dropzone,
        VueEditor
    },
};
</script>

<style>
.table-photo img {
    width: 100px;
    height: 100px;
}

.list-move {
    transition: transform 0.3s;
}

.list-enter-active,
.list-leave-active {
    transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
    transition-property: opacity, transform;
}

.list-enter {
    opacity: 0;
    transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
    opacity: 1;
    transform: translateX(0) scaleY(1);
}

.list-leave-active {
    position: absolute;
}

.list-leave-to {
    opacity: 0;
    transform: scaleY(0);
    transform-origin: center top;
}

.margin-bottom {
    margin-bottom: 24px;
}
</style>